import React from 'react';

import { Button } from '@mui/material';
import { observer } from 'mobx-react';
import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './ChangePasswordRow.module.scss';
import { loggedInUserDataStore } from '../../../../../../../../shared/stores/loggedInUserDataStore';
import { getDescriptionInfo } from './utils/getDescriptionInfo';

type ChangePasswordRowProps = {
  onPasswordChange: () => void;
};

const ChangePasswordRow = observer(({ onPasswordChange }: ChangePasswordRowProps) => {
  const { isSuperAdmin } = loggedInUserDataStore;

  const { title, description } = getDescriptionInfo(isSuperAdmin);
  return (
    <div className={classes.row}>
      <TitleWithDescription
        title={title}
        description={description}
        titleFont="body-14-bold"
        className={classes.title}
      />
      <Button variant="outlined" size="small" onClick={onPasswordChange}>
        Change Password
      </Button>
    </div>
  );
});

export { ChangePasswordRow };
